import React from "react";
import Typography from "@material-ui/core/Typography";

const H5 = (props: any) => (
  <Typography variant="h5" component="h5" gutterBottom {...props} />
);

export default H5;
